import request from './request'

export const loginApi = (data) => {
  return request({
    method: 'post',
    url: '/loginApi',
    data,
    noToken: true
  })
}
export const loginOutApi = (data) => {
  return request({
    method: 'get',
    url: '/logoutAction',
    data
  })
}
export const findPageApi = (data) => {
  return request({
    method: 'post',
    url: '/quality/findPageApi',
    data
  })
}
export const groupListShipmentsApi = (data) => {
  return request({
    method: 'post',
    url: '/shipments/groupListShipmentsApi',
    data
  })
}

// export const downloadQuality = (data) => {
//   return request({
//     method: 'get',
//     url: '/quality/downloadQuality?qualityId=' + data,
//     responseType: 'blob'
//   })
// }



// WEBPACK FOOTER //
// ./src/utils/api.js